
import React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby"

const Seo = ({ pageName, pageMeta, pageNoIndex, meta_image, featured_image }) => {
  const { site, settings } = useStaticQuery(graphql`
  query HeadingQuery {
    site: site {
      siteMetadata {
        title
        description
        image
      }
    }
    settings: storyblokEntry(slug: {eq: "settings"}) {
      id
      content
    }
  }
  `)
  const titleTemplate = (props) => `${props} | ${site.siteMetadata.title}`
  const favicon = JSON.parse(settings.content).favicon?.filename
    return (
      <Helmet>
          {favicon && <link rel="icon" type="image" href={favicon}></link>}
          {pageNoIndex && <meta name="robots" content="noindex,nofollow"></meta>}
          <title>{pageMeta?.title || titleTemplate(pageName)}</title>
          <meta name="description" content={pageMeta?.description || site.siteMetadata.description} />
          <meta name="image" content={meta_image?.filename || featured_image?.filename || site.siteMetadata.image} />
          <meta property="og:title" content={pageMeta?.og_title ? pageMeta?.og_title : pageMeta?.title ? pageMeta?.title : titleTemplate(pageName)} />
          <meta property="og:description" content={pageMeta?.og_description ? pageMeta?.og_description : pageMeta?.description ? pageMeta?.description : site.siteMetadata.description} />
          <meta property="og:image" content={meta_image?.filename || featured_image?.filename || site.siteMetadata.image} />
          <meta property="og:type" content="website" />
          <meta name="twitter:title" content={pageMeta?.twitter_title ? pageMeta?.twitter_title : pageMeta?.title ? pageMeta?.title : titleTemplate(pageName)} />
          <meta name="twitter:description" content={pageMeta?.twitter_description ? pageMeta?.twitter_description : pageMeta?.description ? pageMeta?.description : site.siteMetadata.description} />
          <meta name="twitter:image" content={pageMeta?.twitter_image || site.siteMetadata.image} />
      </Helmet>
    )
}
export default Seo